export enum DeferChoice {
  Asap = 'ASAP',
  Today = 'Today',
  Future = 'Future',
}
